import React, { useEffect, useState } from "react";
import general from "../../../general";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import { splitStr } from "../../../utils/commonFunc";
import { useLogin } from "../../../lib/LoginContext";

// 新游预约
export default (props) => {
  const { setShowLogin } = useLogin();

  const [loading, setLoading] = useState();
  const [gameGroups, setGameGroups] = useState({});
  const [more, setMore] = useState(true);
  const load = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      pagination: { page: 1, count: 100 },
    };

    general.axios
      .post("/v3/reserveGames", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then(({ data: resData }) => {
        if (!resData?.status?.succeed) {
          Dialog.error(resData?.status?.error_desc || "获取预约游戏失败");
          return;
        }

        const result = resData.data || {};
        const nextGameGroups = {};

        for (const game of result.game_list || []) {
          let gameDate = dayjs.unix(game.starting_time);
          let group = gameDate.format("MM/DD");

          const today = dayjs();
          const tomorrow = today.add(1, "day");
          const dayAfterTomorrow = today.add(2, "day");

          if (gameDate.isSame(tomorrow, "day")) {
            group += " 明天上线";
          } else if (gameDate.isSame(dayAfterTomorrow, "day")) {
            group += " 后天上线";
          }

          if (!nextGameGroups[group]) {
            nextGameGroups[group] = [];
          }

          const index = nextGameGroups[group].findIndex(
            (value) => value.game_id === game.game_id,
          );
          if (index === -1) {
            nextGameGroups[group].push(game);
          } else {
            nextGameGroups[group][index] = game;
          }
        }
        setGameGroups(nextGameGroups);
        setMore(result.paginated?.more);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const [commingGames, setCommingGames] = useState([]);
  const [exposureTitle, setExposureTitle] = useState("");
  const [exposureGames, setExposureGames] = useState([]);
  const getCommingData = () => {
    let tmp = {
      pagination: { page: 1, count: 100 },
    };

    general.axios
      .post("/v3/base/game/getCommingSoonGameList", tmp)
      .then(({ data: resData }) => {
        console.log("即将上线列表----", resData);

        let result = resData.data;
        setCommingGames([...result.game_list]);

        setExposureTitle(result?.reserve_exposure?.title || "");
        setExposureGames([...result?.reserve_exposure?.game_list]);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  useEffect(() => {
    if (props.active) {
      load();
      getCommingData();
    }
  }, [props.active]);

  const reserveCallback = (game) => {
    if (!general.isLogin()) {
      setShowLogin(true);
      document.body.style.overflow = "hidden";
      return;
    }

    general.axios
      .post(game.is_reserved ? "/v3/cancelReserveGame" : "/v3/reserveGame", {
        id: game.maiyou_gameid,
      })
      .then((res) => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
          return;
        }
        const nextReserved = game.is_reserved === 1 ? 0 : 1;
        // setGameGroups((groups) =>
        //   Object.entries(groups).reduce((nextGroups, [group, games]) => {
        //     nextGroups[group] = games.map((item) =>
        //       item.game_id === game.game_id
        //         ? { ...item, is_reserved: nextReserved }
        //         : item,
        //     );
        //     return nextGroups;
        //   }, {}),
        // );

        Dialog.success(nextReserved ? "预约成功" : "取消预约");

        load();
        getCommingData();
      })
      .catch((err) => Dialog.error("reserveGame " + err.message));
  };

  return (
    <div>
      {exposureGames && exposureGames.length > 0 && (
        <dl className="new-new">
          <dt>{exposureTitle}</dt>
          <dd>
            {exposureGames.map((game) => (
              <Link
                to={`/game?id=${game.game_id}`}
                key={game.game_id}
                className="new-new-item"
              >
                <div className="data">
                  <div className="icon">
                    <Image src={game.game_image?.thumb} />
                  </div>

                  <div className="info">
                    <div className="name">
                      <span>{game.game_name_main || game.game_name}</span>

                      {game?.game_tags?.is_special_server_game == 2 && (
                        <div className="dedicated-server">专服</div>
                      )}
                    </div>

                    <div className="game-labels">
                      {game?.game_tags?.is_free_version == 2 ? (
                        <div className="is-free-version">
                          <span>免费版</span>
                        </div>
                      ) : (
                        <>
                          {game.discount < 1 ? (
                            <div className="is-free-version">
                              {parseFloat((game.discount * 10).toFixed(2))}折
                            </div>
                          ) : null}
                        </>
                      )}

                      <div className="game-classify">
                        {splitStr(game?.game_classify_type)}
                      </div>
                    </div>

                    <div className="subscribe-time">
                      {game.is_comming_soon == 2
                        ? "即将上线"
                        : `${dayjs.unix(game.starting_time).format("MM.DD HH:mm")}首发`}
                    </div>
                  </div>
                </div>

                <div
                  className={
                    game.is_comming_soon == 2 || game.is_reserved
                      ? "active opt"
                      : "opt"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (game.is_comming_soon == 1) {
                      reserveCallback(game);
                    }
                  }}
                >
                  {game.is_comming_soon == 2
                    ? "预约待定"
                    : game.is_reserved
                      ? "已预约"
                      : "预约"}
                </div>
              </Link>
            ))}
          </dd>
        </dl>
      )}

      {gameGroups && Object.entries(gameGroups).length > 0 && (
        <>
          {Object.entries(gameGroups).map(([group, games]) => (
            <dl className="new-new" key={group}>
              <dt>{group}</dt>
              <dd>
                {games.map((game) => (
                  <Link
                    to={`/game?id=${game.game_id}`}
                    key={game.game_id}
                    className="new-new-item"
                  >
                    <div className="data">
                      <div className="icon">
                        <Image src={game.game_image?.thumb} />
                      </div>

                      <div className="info">
                        <div className="name">
                          <span>{game.game_name_main || game.game_name}</span>

                          {game?.game_tags?.is_special_server_game == 2 && (
                            <div className="dedicated-server">专服</div>
                          )}
                        </div>

                        <div className="game-labels">
                          {game?.game_tags?.is_free_version == 2 ? (
                            <div className="is-free-version">
                              <span>免费版</span>
                            </div>
                          ) : (
                            <>
                              {game.discount < 1 ? (
                                <div className="is-free-version">
                                  {parseFloat((game.discount * 10).toFixed(2))}
                                  折
                                </div>
                              ) : null}
                            </>
                          )}

                          <div className="game-classify">
                            {splitStr(game?.game_classify_type)}
                          </div>
                        </div>

                        <div className="subscribe-time">
                          {dayjs.unix(game.starting_time).format("MM.DD HH:mm")}
                          首发
                        </div>
                      </div>
                    </div>

                    <div
                      className={game.is_reserved ? "active opt" : "opt"}
                      onClick={(e) => {
                        e.preventDefault();
                        reserveCallback(game);
                      }}
                    >
                      {game.is_reserved ? "已预约" : "预约"}
                    </div>
                  </Link>
                ))}
              </dd>
            </dl>
          ))}
        </>
      )}

      {commingGames && commingGames.length > 0 && (
        <dl className="new-new">
          <dt>即将上线</dt>
          <dd>
            {commingGames.map((game) => (
              <Link
                to={`/game?id=${game.game_id}`}
                key={game.game_id}
                className="new-new-item"
              >
                <div className="data">
                  <div className="icon">
                    <Image src={game.game_image?.thumb} />
                  </div>

                  <div className="info">
                    <div className="name">
                      <span>{game.game_name_main || game.game_name}</span>

                      {game?.game_tags?.is_special_server_game == 2 && (
                        <div className="dedicated-server">专服</div>
                      )}
                    </div>

                    <div className="game-labels">
                      {game?.game_tags?.is_free_version == 2 ? (
                        <div className="is-free-version">
                          <span>免费版</span>
                        </div>
                      ) : (
                        <>
                          {game.discount < 1 ? (
                            <div className="is-free-version">
                              {parseFloat((game.discount * 10).toFixed(2))}折
                            </div>
                          ) : null}
                        </>
                      )}

                      <div className="game-classify">
                        {splitStr(game?.game_classify_type)}
                      </div>
                    </div>

                    <div className="subscribe-time">即将上线</div>
                  </div>
                </div>

                <div className="active opt">预约待定</div>
              </Link>
            ))}
          </dd>
        </dl>
      )}

      {(Object.entries(gameGroups).length > 0 && !more) ||
      commingGames?.length > 0 ? (
        <div className="view-end">别撩啦！已经到底啦~</div>
      ) : null}
    </div>
  );
};
